
export const formPlaceholders = {
  // Name fields
  name: "Ex: Conta Corrente",
  cardName: "Ex: Cartão Principal",
  budgetName: "Ex: Alimentação",
  goalName: "Ex: Reserva de Emergência",
  debtName: "Ex: Financiamento Casa",
  categoryName: "Ex: Transporte",
  releaseName: "Ex: Salário, Aluguel, Financiamento...",
  
  // Value fields
  amount: "R$ 0,00",
  value: "R$ 0,00",
  goalValue: "R$ 0,00",
  budgetValue: "R$ 0,00",
  initialBalance: "R$ 0,00",
  limit: "R$ 0,00",
  releaseValue: "R$ 0,00",
  
  // Description fields
  description: "Digite uma descrição (opcional)",
  transactionDescription: "Ex: Pagamento de conta",
  notes: "Digite suas observações...",
  
  // Date fields
  date: "Selecionar data",
  dueDate: "Selecionar data de vencimento",
  
  // Selection fields
  account: "Selecionar conta",
  card: "Selecionar cartão",
  category: "Selecionar categoria",
  bank: "Selecionar banco",
  type: "Selecionar tipo",
  paymentMethod: "Selecionar método",
  
  // Text fields with limits
  shortDescription: "Digite uma descrição breve (máx. 100 caracteres)",
  longDescription: "Digite uma descrição detalhada (máx. 500 caracteres)",
  
  // Numbers
  installments: "Número de parcelas",
  accountNumber: "Ex: 12345-6",
  
  // Email and password
  email: "seu@email.com",
  password: "Digite sua senha",
  confirmPassword: "Confirme sua senha"
} as const;

export type PlaceholderKey = keyof typeof formPlaceholders;
